import styled from "styled-components";

const primary = "#6c63ff";
const primaryLight = "#8a84ff";
const background = "#f9f9fb";
const cardBg = "#ffffff";
const softGray = "#f0f2f5";
const textMain = "#2e2e3a";
const textSecondary = "#73758c";
const borderColor = "#e4e6f1";
const success = "#4caf50";
const warning = "#ff9800";
const error = "#f44336";

export const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 24px 0;
  gap: 20px;
  flex-wrap: wrap;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
`;

export const FilterLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: ${textMain};
  cursor: pointer;
  user-select: none;
`;

export const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: ${primary};
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${primaryLight};
    transform: translateY(-1px);
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 300px;

  svg {
    position: absolute;
    left: 12px;
    color: ${textSecondary};
    z-index: 1;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 12px 12px 12px 40px;
  border: 1px solid ${borderColor};
  border-radius: 8px;
  font-size: 14px;
  background: ${cardBg};
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${primary};
    box-shadow: 0 0 0 3px rgba(108, 99, 255, 0.1);
  }

  &::placeholder {
    color: ${textSecondary};
  }
`;

export const TableContainer = styled.div`
  background: ${cardBg};
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
`;

export const Table = styled.div`
  width: 100%;
`;

export const TableHead = styled.div`
  background: ${softGray};
  border-bottom: 1px solid ${borderColor};
`;

export const TableBody = styled.div`
  background: ${cardBg};
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 0.2fr 0.2fr 1fr 1.5fr 1fr 0.8fr;
  gap: 1px;
  background: ${props => props.isRemoved ? "#fff5f5" : "transparent"};
  border-bottom: 1px solid ${borderColor};
  transition: all 0.2s ease;

  &:hover {
    background: ${softGray};
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const TableHeader = styled.div`
  padding: 16px 12px;
  font-weight: 600;
  font-size: 14px;
  color: ${textMain};
  text-align: left;
`;

export const TableCell = styled.div`
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 80px;
`;

export const StudentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const StudentName = styled.div`
  font-weight: 600;
  color: ${textMain};
  font-size: 14px;
`;

export const StudentId = styled.div`
  font-size: 12px;
  color: ${textSecondary};
`;

export const StudentDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-top: 4px;

  span {
    font-size: 11px;
    color: ${textSecondary};
  }
`;

export const TeacherInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: ${textMain};

  svg {
    color: ${primary};
    flex-shrink: 0;
  }
`;

export const TeacherId = styled.div`
  font-size: 11px;
  color: ${textSecondary};
  margin-top: 2px;
`;

export const PlatformBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #e8f5e8;
  color: ${success};
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  margin-top: 6px;
  width: fit-content;
`;

export const ContactInfo = styled.div`
  font-size: 13px;
  color: ${textMain};
  font-family: 'Courier New', monospace;
`;

export const ScheduleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ScheduleItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ScheduleChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  background: ${softGray};
  border-radius: 6px;
  font-size: 12px;
  color: ${textMain};
  margin-right: 6px;
  margin-bottom: 4px;
`;

export const EditableField = styled.span`
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid transparent;

  &:hover {
    background: ${softGray};
    border-color: ${primary};
  }
`;

export const Select = styled.select`
  padding: 6px 8px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 13px;
  background: ${cardBg};
  min-width: 120px;

  &:focus {
    outline: none;
    border-color: ${primary};
  }
`;

export const TimeInput = styled.input`
  padding: 6px 8px;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 13px;
  background: ${cardBg};
  min-width: 100px;

  &:focus {
    outline: none;
    border-color: ${primary};
  }
`;

export const SaveButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: ${primary};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: fit-content;

  &:hover {
    background: ${primaryLight};
  }
`;

export const StatusSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid ${borderColor};
  border-radius: 6px;
  font-size: 13px;
  background: ${cardBg};
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;

  &:focus {
    outline: none;
    border-color: ${primary};
    box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.1);
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RemoveButton = styled.button`
  padding: 6px 12px;
  background: ${error};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #d32f2f;
  }
`;

export const SecondaryButton = styled.button`
  padding: 6px 12px;
  background: transparent;
  color: ${textSecondary};
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${softGray};
    color: ${textMain};
  }
`;

// Styles for All Admin view (columns layout)
export const ColumnsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 20px;
  padding: 20px;
`;

export const LanguageColumn = styled.div`
  background: ${softGray};
  border-radius: 8px;
  overflow: hidden;
`;

export const ColumnHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: ${primary};
  color: white;
`;

export const ColumnTitle = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
`;

export const CountBadge = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const CardsList = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 600px;
  overflow-y: auto;
`;

export const Card = styled.div`
  background: ${cardBg};
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
`;

export const CardHeader = styled.div`
  margin-bottom: 12px;
`;

// Toggle styles (keep from original)
export const ToggleSwitch = styled.div`
  width: 40px;
  height: 20px;
  background: ${({ checked }) => (checked ? primary : "#ccc")};
  border-radius: 10px;
  position: relative;
  transition: background 0.3s;
  cursor: pointer;
`;

export const ToggleThumb = styled.div`
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: ${({ checked }) => (checked ? "22px" : "2px")};
  transition: left 0.3s;
`;



export const NotesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;

export const NotesDisplay = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 2px;
  background: ${props => props.hasNotes ? "#fff9e6" : softGray};
  border: 1px solid ${props => props.hasNotes ? "#ffd700" : borderColor};
  border-radius: 6px;
  font-size: 14px;
  color: ${props => props.hasNotes ? textMain : textSecondary};
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 80px;
  line-height: 1.4;

  &:hover {
    background: ${props => props.hasNotes ? "#fff5cc" : "#e8eaf1"};
    border-color: ${primaryLight};
  }

  svg {
    color: ${props => props.hasNotes ? "#ffd700" : textSecondary};
    flex-shrink: 0;
    margin-top: 1px;
  }
`;

export const NotesTextarea = styled.textarea`
  padding: 8px;
  border: 1px solid ${primary};
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  min-height: 60px;
  line-height: 1.4;
  background: ${cardBg};

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.1);
  }

  &::placeholder {
    color: ${textSecondary};
  }
`;

export const NotesActions = styled.div`
  display: flex;
  gap: 6px;
  justify-content: flex-end;
`;

export const EditNoteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background: transparent;
  border: 1px solid ${borderColor};
  border-radius: 4px;
  color: ${textSecondary};
  font-size: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: absolute;
  top: 8px;
  right: 8px;

  &:hover {
    background: ${softGray};
    color: ${textMain};
    border-color: ${primaryLight};
  }
`;

export const CancelButton = styled.button`
  padding: 6px 12px;
  background: transparent;
  color: ${textSecondary};
  border: 1px solid ${borderColor};
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${softGray};
    color: ${textMain};
  }
`;

export const NotesSection = styled.div`
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid ${borderColor};
`;

export const NotesLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  color: ${textMain};
  margin-bottom: 4px;

  svg {
    color: #ffd700;
  }
`;

export const NotesText = styled.div`
  font-size: 12px;
  color: ${textMain};
  line-height: 1.4;
  background: #fff9e6;
  padding: 8px;
  border-radius: 4px;
  border-left: 3px solid #ffd700;
`;

